import React from 'react';

import { HStack } from '@chakra-ui/react';

import { PageHeaderWithIcon } from 'components/DataDisplay';
import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';
import { FormAction } from 'components/DataEntry';
import { LearnMoreButton } from 'components/DataEntry/Button/LearnMoreButton';
import { PolicyOldIcon } from 'components/Icons';

interface Props {
  action: FormAction;
}

export const DataPolicyFormTitle = (props: Props) => {
  const { action } = props;
  const { setLearnMore } = useKnowledgeBase();
  return (
    <HStack justify="space-between" w="full">
      <PageHeaderWithIcon
        label={action + ' Data Policy'}
        icon={<PolicyOldIcon />}
      />
      <LearnMoreButton
        onOpen={() => setLearnMore('data_policy')}
        label="Data Policy"
      />
    </HStack>
  );
};
